<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <div class="head-banner layout-banner high unique-component fadeUp"  :class="animate ? 'animate' : ''">
      <div class="img-box paralaxe">
        <picture>
          <!-- <source media="(max-width: 767px)" :srcset="_.get(itemData, 'media.cover.devices.mobile')" />
          <source media="(max-width: 1023px)" :srcset="_.get(itemData, 'media.cover.devices.tablet')" />-->
          <img :src="_.get(itemData, 'media.cover.devices.desktop')" class="img-absolute" :class="{ 'no-opacity': hasNoOpacity }" alt />
        </picture>
        <div class="gradient" :class="{ 'no-gradient': hasNoGradient }"></div>
        <div class="container widget-content">
          <h1 class="main-title white">{{_.get(itemData, 'title')}}</h1>
          <p class="white">{{_.get(itemData, 'teaser')}}</p>
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Vue from "vue";
import MainMixin from "@/mixins/main";
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);
export default {
  mixins: [MainMixin, AliMixin],
  components: { Intersect },
  data(){
    return {
      animate:false,
    }
  },
  props: {
    itemData: Object,
  },
  computed: {
    hasNoGradient() {
      let selectedMenu = this.getMenuFromPath();
      if (selectedMenu && selectedMenu.css.includes("disable-cover-gradient")) {
        return true
      }

      return false
    },
    hasNoOpacity() {
      let selectedMenu = this.getMenuFromPath();
      if (selectedMenu && selectedMenu.css.includes("disable-cover-opacity")) {
        return true
      }

      return false
    }
  },
  mounted() {
    this.startParalaxe();
  },
};
</script>
